import {
  GET_STATUS_COUNT,
  GET_STATUS_COUNT_SUCCESS,
  GET_STATUS_COUNT_FAIL,
  GET_COLUMN_DATA,
  GET_COLUMN_DATA_SUCCESS,
  GET_COLUMN_DATA_FAIL,
  GET_INVESTIGATION_DATA,
  GET_INVESTIGATION_SUCCESS,
  GET_INVESTIGATION_FAIL,
  SET_DATE_RANGE
} from '../../actions/tm/investigation';
import moment from 'moment';
export const initialState = {
  isLoading: false,
  listingResp: {
    data: null
  },
  statusDataResp: {
    data: null
  },
  dateRange: {
    startDate: moment().subtract(30, 'days').add(1, 'days'),
    endDate: moment(),
    activeRangeNo: 2
  }
};

function investigation(state = initialState, action) {
  switch (action.type) {
    case GET_STATUS_COUNT:
      return {
        ...state
      };
    case GET_STATUS_COUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        statusDataResp: {
          ...action.payload
        }
      };
    case GET_STATUS_COUNT_FAIL:
      return {
        ...state
      };
    case GET_COLUMN_DATA:
      return {
        ...state
      };
    case GET_COLUMN_DATA_SUCCESS:
      return {
        ...state,
        columnData: action.payload.column_data
      };
    case GET_COLUMN_DATA_FAIL:
      return {
        ...state
      };
    case GET_INVESTIGATION_DATA:
      return {
        ...state,
        isLoading: true
      };
    case GET_INVESTIGATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        listingResp: {
          ...action.payload
        }
      };
    case GET_INVESTIGATION_FAIL:
      return {
        ...initialState
      };
    case SET_DATE_RANGE:
      return {
        ...state,
        dateRange: {
          ...action.payload
        }
      };
    default:
      return state;
  }
}

export default investigation;
